import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@components';
import { ProductSubcategoriesPropType } from '@propTypes';
import { PRODUCT_MENU_STATE_ENUM } from '../constants';
import { useHeaderContext } from '../../../../../HeaderContext';

import styles from './styles/index.module.scss';

const Subcategory = ({ menuState, subcategories }) => {
  const { platformBaseUrl } = useHeaderContext();

  return !(menuState === PRODUCT_MENU_STATE_ENUM.SUBCATEGORIES) ? null : (
    <ul className={styles.subcategoryMenu} data-qa="subcategoriesList">
      {subcategories.map(({ id, name, url, product_count: productCount }) => (
        <li className={styles.subcategoryItem} key={id}>
          <Button
            color="transparent"
            tag="a"
            className={styles.subcategoryTab}
            href={`${platformBaseUrl}${url}`}
          >
            {name} ({productCount})
          </Button>
        </li>
      ))}
    </ul>
  );
};

Subcategory.propTypes = {
  menuState: PropTypes.string.isRequired,
  subcategories: ProductSubcategoriesPropType.isRequired,
};

export default Subcategory;
